import axios from 'axios'
import router from "../router";

const request = axios.create({
    baseURL: 'https://kcsk.hyicloud.com/iirms',
    //baseURL: 'http://192.168.0.17:9503/iirms',
})

// request 拦截器
// 可以自请求发送前对请求做一些处理
// 比如统一加token，对请求参数统一加密
request.interceptors.request.use(config => {
    config.headers['Content-Type'] = 'application/json;charset=utf-8';
    let khdbh = 'BROWSER';
    config.headers['khdbh'] = khdbh;
    let token = localStorage.getItem("token") ? localStorage.getItem("token") : null
     if (token) {
         config.headers['token'] = token;  // 设置请求头
         localStorage.setItem("tokenDate",new Date().getTime())
     }
    let skCd = localStorage.getItem("skCd") ? localStorage.getItem("skCd") : null
    //console.log("skCd",skCd)
    if(skCd){
        config.headers['resCd'] = skCd;  // 设置请求头
    }
    return config
}, error => {
    return Promise.reject(error)
});

// response 拦截器
// 可以在接口响应后统一处理结果
request.interceptors.response.use(

    response => {
        let res = response.data;
        // 如果是返回的文件
        if (response.config.responseType === 'blob') {
            return response
        }
        // 兼容服务端返回的字符串数据
        if (typeof res === 'string') {
            res = res ? JSON.parse(res) : res
        }
        // 当权限验证不通过的时候给出提示
        if (!res.ok && (res.error.code == '1001' || res.error.code == '1002' || res.error.code == '1007')) {
            //清空本地用户
            /*Cookies.remove("zh");
            Cookies.remove("mm");
            Cookies.remove('rememberMe');*/
            localStorage.removeItem("token")
            router.replace('/login')
        }
        return res;
    },
     error => {
        // console.log('err' + error) // for debug
        return Promise.reject(error)
    }
)


export default request

